export const getDetailsFieldName = (saleType) => `${saleType}Details`;
export const getInterestedFieldName = (saleType) => `${saleType}Interested`;
